/**
 * admin-zone.guard.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Injectable } from "@angular/core";
import { CanActivate, CanLoad } from "@angular/router";
import { AlgorithmService } from "../algorithms/management/algorithm.service";

@Injectable()
export class AdminZoneGuard implements CanActivate, CanLoad {
  constructor (private algorithms : AlgorithmService) {/* DI */}

  public run () : boolean
  {
    return this.algorithms.zoneIsAdmin;
  }

  public canActivate () : boolean
  {
    return this.run();
  }
  public canLoad () : boolean
  {
    return this.run();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/routing/admin-zone.guard.ts